<template>
    <span>ici la page 404</span>
</template>